import { render } from "./ProductCarousel.vue?vue&type=template&id=5534cd56&scoped=true"
import script from "./ProductCarousel.vue?vue&type=script&lang=js"
export * from "./ProductCarousel.vue?vue&type=script&lang=js"

import "./ProductCarousel.vue?vue&type=style&index=0&id=5534cd56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5534cd56"]])

export default __exports__